import store from '@/store';

/**
 * 用于js判断是否有权限
 *  用法：import { hasPermission } from '@/libs/permissions'
 * @param {*} permission 需要判断的权限列表
 * @param {*} relation 需要判断的关系，and或者or、ban，默认是and
 * @returns
 */
export function hasApiMenuPermission(relation = 'and', permission) {
  // 如果permission不是数组，直接返回false
  if (!Array.isArray(permission)) {
    console.error('hasPermission函数的第二个参数必须是数组');
    return false;
  }

  // 如果relation不是and、or、ban，直接返回false
  if (['and', 'or', 'ban'].includes(relation) === false) {
    console.error('hasPermission函数的第一个参数必须是and、or、ban');
    return false;
  }

  // 如果是普通用户，判断是否有权限
  const { authList, isSuperAdmin } = store.state;

  // 如果是超级管理员，直接返回true
  if (isSuperAdmin) {
    return true;
  }

  // and
  if (relation === 'and') {
    // 如果permission数组中的每一项都在permissions数组中，返回true
    return permission.every(item => {
      return authList.includes(item);
    });
  } else if (relation === 'or') {
    // 如果permission数组中的任意一项在authList数组中，返回true
    return permission.some(item => {
      return authList.includes(item);
    });
  } else if (relation === 'ban') {
    // 如果permission数组中的每一项都不在authList数组中，返回true
    return permission.every(item => {
      return !authList.includes(item);
    });
  }

  // 默认返回false
  return false;
}

/**
 * 判断是否有写的权限
 * 对比user.role.xxWrite的值
 * 用法：import { hasReadWritePermission } from '@/libs/permissions'
 * @param {*} authType 用户的读写权限的类型,read 或 write
 * @param {*} userRoleLevel 用户的读写权限的类型,暂时只有3个： wiki、attach、deviceConfig、deviceParams、user，其他则返回false
 * wiki - 文档的读、写权限
 * attach - 附件的读、写权限
 * deviceConfig - 设备配置的读权限
 * deviceParams - 设备参数的读、写权限
 * user - 用户操作的权限
 * @param {*} itemLevelField 当前项的读写权限
 * @returns
 */
export function hasReadWritePermission(authType, userLevelType, itemLevel) {
  // 如果authType不是字符串，直接返回false
  if (!['read', 'write'].includes(authType)) {
    console.error('hasWritePermission函数的第一个参数必须是字符串、且只能是read或write中的一个');
    return false;
  }

  // 如果userLevelType不是字符串，直接返回false
  if (!['wiki', 'attach', 'deviceConfig', 'deviceParams', 'user'].includes(userLevelType)) {
    console.error(
      'hasWritePermission函数的第二个参数必须是字符串、且只能是 wiki、attach、deviceConfig、deviceParams、user中的一个'
    );
    return false;
  }

  // 如果itemLevel为空，直接返回false
  if (typeof itemLevel === 'undefined') {
    console.error('hasWritePermission函数的第三个参数不能为空，为空时权限反回false');
    return false;
  }

  // 如果是超级管理员，直接返回true
  // if (store.state.isSuperAdmin) {
  //   console.info('超级管理员，直接返回true');
  //   return true;
  // }
  const userInfo = store.state.userInfo;

  // 是文档
  if (userLevelType === 'wiki') {
    if (authType === 'read') {
      return userInfo.role.wikiReadLevel <= itemLevel;
    }
    return userInfo.role.wikiWriteLevel <= itemLevel;
  }

  // 是附件
  if (userLevelType === 'attach') {
    if (authType === 'read') {
      return userInfo.role.attachReadLevel <= itemLevel;
    }
    return userInfo.role.attachWriteLevel <= itemLevel;
  }

  // 是设备参数
  if (userLevelType === 'deviceParams') {
    if (authType === 'read') {
      return userInfo.role.paramReadLevel <= itemLevel;
    }
    return userInfo.role.paramWriteLevel <= itemLevel;
  }

  // 是设备配置，不区分读写权限
  if (userLevelType === 'deviceConfig') {
    return userInfo.role.cfgReadLevel <= itemLevel;
  }

  // 是用户，不区分读写权限
  if (userLevelType === 'user') {
    return userInfo.role.userRangeLevel <= itemLevel;
  }

  return false;
}
